import { useState, useEffect, useCallback } from 'react';
import { TOCTitle } from './table-of-contents.component';

const useHeadingsData = ({ content = null }) => {
  const [headings, setHeadings] = useState(null);

  const updateHeadings = useCallback(() => {
    const container = document.querySelector('#content-container');

    if (!container) {
      setHeadings([]);
      return;
    }
    const headingElements = Array.from(container.querySelectorAll('h1, h2, h3'));

    const headingResult = headingElements
      .map((el, index) => {
        const level = Number(el.nodeName.charAt(1));
        const id = `${el.nodeName}-${index}`;

        return {
          key: id,
          title: <TOCTitle level={level} title={el.innerText} />,
          href: `#${id}`,
          level,
        };
      })
      .reduce((acc, item) => {
        if (item.level === 1) {
          acc.push({ ...item, children: [] });
        } else if (item.level === 2) {
          let last = acc[acc.length - 1];
          if (last && last.level === 1) {
            last.children.push({ ...item, children: [] });
          }
        } else if (item.level === 3) {
          let lastLevel1 = acc[acc.length - 1];
          if (lastLevel1 && lastLevel1.children) {
            let lastLevel2 = lastLevel1.children[lastLevel1.children.length - 1];
            if (lastLevel2 && lastLevel2.level === 2) {
              lastLevel2.children.push(item);
            }
          }
        }
        return acc;
      }, [])
      .map(parentItem => {
        if (parentItem.children && parentItem.children.length === 0) {
          delete parentItem.children;
        } else {
          parentItem.children = parentItem.children.map(childItem => {
            if (childItem.children && childItem.children.length === 0) {
              delete childItem.children;
            }
            return childItem;
          });
        }
        return parentItem;
      });

    setHeadings(headingResult);
  }, []);

  useEffect(() => {
    updateHeadings();
  }, [content, updateHeadings]);

  return { headings };
};

export { useHeadingsData };
